import { render, staticRenderFns } from "./waterfall-board-form-task.vue?vue&type=template&id=b4ed00c8&"
import script from "./waterfall-board-form-task.vue?vue&type=script&lang=js&"
export * from "./waterfall-board-form-task.vue?vue&type=script&lang=js&"
import style0 from "./waterfall-board-form-task.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports